export default __webpack_public_path__ + "static/media/redemption_navicon.1be1745a.svg";